export default __webpack_public_path__ + "static/media/account-key.a34a68a9.svg";